// Component names
export const NAME_ALERT = 'BAlert'
export const NAME_ASPECT = 'BAspect'
export const NAME_AVATAR = 'BAvatar'
export const NAME_AVATAR_GROUP = 'BAvatarGroup'
export const NAME_BADGE = 'BBadge'
export const NAME_BREADCRUMB = 'BBreadcrumb'
export const NAME_BREADCRUMB_ITEM = 'BBreadcrumbItem'
export const NAME_BREADCRUMB_LINK = 'BBreadcrumbLink'
export const NAME_BUTTON = 'BButton'
export const NAME_BUTTON_CLOSE = 'BButtonClose'
export const NAME_BUTTON_GROUP = 'BButtonGroup'
export const NAME_BUTTON_TOOLBAR = 'BButtonToolbar'
export const NAME_CALENDAR = 'BCalendar'
export const NAME_CARD = 'BCard'
export const NAME_CARD_BODY = 'BCardBody'
export const NAME_CARD_FOOTER = 'BCardFooter'
export const NAME_CARD_GROUP = 'BCardGroup'
export const NAME_CARD_HEADER = 'BCardHeader'
export const NAME_CARD_IMG = 'BCardImg'
export const NAME_CARD_IMG_LAZY = 'BCardImgLazy'
export const NAME_CARD_SUB_TITLE = 'BCardSubTitle'
export const NAME_CARD_TEXT = 'BCardText'
export const NAME_CARD_TITLE = 'BCardTitle'
export const NAME_CAROUSEL = 'BCarousel'
export const NAME_CAROUSEL_SLIDE = 'BCarouselSlide'
export const NAME_COL = 'BCol'
export const NAME_COLLAPSE = 'BCollapse'
export const NAME_CONTAINER = 'BContainer'
export const NAME_DROPDOWN = 'BDropdown'
export const NAME_DROPDOWN_DIVIDER = 'BDropdownDivider'
export const NAME_DROPDOWN_FORM = 'BDropdownForm'
export const NAME_DROPDOWN_GROUP = 'BDropdownGroup'
export const NAME_DROPDOWN_HEADER = 'BDropdownHeader'
export const NAME_DROPDOWN_ITEM = 'BDropdownItem'
export const NAME_DROPDOWN_ITEM_BUTTON = 'BDropdownItemButton'
export const NAME_DROPDOWN_TEXT = 'BDropdownText'
export const NAME_EMBED = 'BEmbed'
export const NAME_FORM = 'BForm'
export const NAME_FORM_CHECKBOX = 'BFormCheckbox'
export const NAME_FORM_CHECKBOX_GROUP = 'BFormCheckboxGroup'
export const NAME_FORM_DATALIST = 'BFormDatalist'
export const NAME_FORM_DATEPICKER = 'BFormDatepicker'
export const NAME_FORM_FILE = 'BFormFile'
export const NAME_FORM_GROUP = 'BFormGroup'
export const NAME_FORM_INPUT = 'BFormInput'
export const NAME_FORM_INVALID_FEEDBACK = 'BFormInvalidFeedback'
export const NAME_FORM_RADIO = 'BFormRadio'
export const NAME_FORM_RADIO_GROUP = 'BFormRadioGroup'
export const NAME_FORM_RATING = 'BFormRating'
export const NAME_FORM_ROW = 'BFormRow'
export const NAME_FORM_SELECT = 'BFormSelect'
export const NAME_FORM_SELECT_OPTION = 'BFormSelectOption'
export const NAME_FORM_SELECT_OPTION_GROUP = 'BFormSelectOptionGroup'
export const NAME_FORM_SPINBUTTON = 'BFormSpinbutton'
export const NAME_FORM_TAG = 'BFormTag'
export const NAME_FORM_TAGS = 'BFormTags'
export const NAME_FORM_TEXT = 'BFormText'
export const NAME_FORM_TEXTAREA = 'BFormTextarea'
export const NAME_FORM_TIMEPICKER = 'BFormTimepicker'
export const NAME_FORM_VALID_FEEDBACK = 'BFormValidFeedback'
export const NAME_ICON = 'BIcon'
export const NAME_ICONSTACK = 'BIconstack'
export const NAME_ICON_BASE = 'BIconBase'
export const NAME_IMG = 'BImg'
export const NAME_IMG_LAZY = 'BImgLazy'
export const NAME_INPUT_GROUP = 'BInputGroup'
export const NAME_INPUT_GROUP_ADDON = 'BInputGroupAddon'
export const NAME_INPUT_GROUP_APPEND = 'BInputGroupAppend'
export const NAME_INPUT_GROUP_PREPEND = 'BInputGroupPrepend'
export const NAME_INPUT_GROUP_TEXT = 'BInputGroupText'
export const NAME_JUMBOTRON = 'BJumbotron'
export const NAME_LINK = 'BLink'
export const NAME_LIST_GROUP = 'BListGroup'
export const NAME_LIST_GROUP_ITEM = 'BListGroupItem'
export const NAME_MEDIA = 'BMedia'
export const NAME_MEDIA_ASIDE = 'BMediaAside'
export const NAME_MEDIA_BODY = 'BMediaBody'
export const NAME_MODAL = 'BModal'
export const NAME_MSG_BOX = 'BMsgBox'
export const NAME_NAV = 'BNav'
export const NAME_NAVBAR = 'BNavbar'
export const NAME_NAVBAR_BRAND = 'BNavbarBrand'
export const NAME_NAVBAR_NAV = 'BNavbarNav'
export const NAME_NAVBAR_TOGGLE = 'BNavbarToggle'
export const NAME_NAV_FORM = 'BNavForm'
export const NAME_NAV_ITEM = 'BNavItem'
export const NAME_NAV_ITEM_DROPDOWN = 'BNavItemDropdown'
export const NAME_NAV_TEXT = 'BNavText'
export const NAME_OVERLAY = 'BOverlay'
export const NAME_PAGINATION = 'BPagination'
export const NAME_PAGINATION_NAV = 'BPaginationNav'
export const NAME_POPOVER = 'BPopover'
export const NAME_PROGRESS = 'BProgress'
export const NAME_PROGRESS_BAR = 'BProgressBar'
export const NAME_ROW = 'BRow'
export const NAME_SIDEBAR = 'BSidebar'
export const NAME_SKELETON = 'BSkeleton'
export const NAME_SKELETON_ICON = 'BSkeletonIcon'
export const NAME_SKELETON_IMG = 'BSkeletonImg'
export const NAME_SKELETON_TABLE = 'BSkeletonTable'
export const NAME_SKELETON_WRAPPER = 'BSkeletonWrapper'
export const NAME_SPINNER = 'BSpinner'
export const NAME_TAB = 'BTab'
export const NAME_TABLE = 'BTable'
export const NAME_TABLE_CELL = 'BTableCell'
export const NAME_TABLE_LITE = 'BTableLite'
export const NAME_TABLE_SIMPLE = 'BTableSimple'
export const NAME_TABS = 'BTabs'
export const NAME_TBODY = 'BTbody'
export const NAME_TFOOT = 'BTfoot'
export const NAME_TH = 'BTh'
export const NAME_THEAD = 'BThead'
export const NAME_TIME = 'BTime'
export const NAME_TOAST = 'BToast'
export const NAME_TOASTER = 'BToaster'
export const NAME_TOOLTIP = 'BTooltip'
export const NAME_TR = 'BTr'

// Helper component names
export const NAME_COLLAPSE_HELPER = 'BVCollapse'
export const NAME_FORM_BUTTON_LABEL_CONTROL = 'BVFormBtnLabelControl'
export const NAME_FORM_RATING_STAR = 'BVFormRatingStar'
export const NAME_POPOVER_HELPER = 'BVPopover'
export const NAME_POPOVER_TEMPLATE = 'BVPopoverTemplate'
export const NAME_POPPER = 'BVPopper'
export const NAME_TAB_BUTTON_HELPER = 'BVTabButton'
export const NAME_TOAST_POP = 'BVToastPop'
export const NAME_TOOLTIP_HELPER = 'BVTooltip'
export const NAME_TOOLTIP_TEMPLATE = 'BVTooltipTemplate'
export const NAME_TRANSITION = 'BVTransition'
export const NAME_TRANSPORTER = 'BVTransporter'
export const NAME_TRANSPORTER_TARGET = 'BVTransporterTarget'
